import React from 'react';

import Dashboard from 'components/Dashboard';
import { ChildrenProps } from 'models/props';
import { useIsLessThan } from 'fxs-utils';

import { FXSTwoCols } from './styles';

export default function TwoColsMainLayout({ children }: ChildrenProps) {
	const isLessThan833 = useIsLessThan(833);
	const isLessThan1280 = useIsLessThan(1280);

	return (
		<Dashboard>
			<FXSTwoCols
				isLessThan833={isLessThan833}
				isLessThan1280={isLessThan1280}
			>
				{children}
			</FXSTwoCols>
		</Dashboard>
	);
}
